import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import {
  DateTimeFormat,
  DateTimeFormatSimple,
} from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'

// 首营品种管理
export const Columns = (
  onClick: (text: string, t: any, flag?: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '门店名称',
      dataIndex: 'tenantName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantName ? t.tenantName : '-'
      },
    },
    {
      title: '自编码',
      dataIndex: 'no',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.no ? t.no : '-'
      },
    },
    {
      title: '商品名',
      dataIndex: 'name',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.name ? t.name : '-'
      },
    },
    // 新老目录展示方式 spec=>packSpec
    {
      title: '规格',
      dataIndex: 'packSpec',
      align: 'center',
      width: '5rem',
      ellipsis: true,
      render: (_, t) => {
        return t.packSpec ? t.packSpec : '-'
      },
    },
    {
      title: '单位',
      dataIndex: 'accountUnit',
      align: 'center',
      width: '4rem',
      ellipsis: true,
      render: (_, t) => {
        return t.accountUnit ? t.accountUnit : '-'
      },
    },
    {
      title: '批准文号或进口注册证号',
      dataIndex: 'approvalNumber',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.approvalNumber ? t.approvalNumber : '-'
      },
    },
    {
      title: '生产企业(产地)',
      dataIndex: 'tenantSupplierName',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantSupplierName ? t.tenantSupplierName : '-'
      },
    },
    {
      title: '供应商',
      dataIndex: 'normalGysName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.normalGysName ? t.normalGysName : '-'
      },
    },
    {
      title: '首营日期',
      dataIndex: 'firstTime',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.firstTime
          ? moment(t.firstTime).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '数据录入时间',
      dataIndex: 'createTime',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.createTime ? moment(t.createTime).format(DateTimeFormat) : '-'
      },
    },
    {
      title: '采购意见',
      dataIndex: 'buyOpinionFlag',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <>
            {t?.buyOpinionFlag == 0 ? (
              <Button
                type='link'
                size='small'
                disabled={t?.isEdit?.toString() == '0' ? true : false}
                onClick={() => {
                  onClick('goForReview', t, '1')
                }}
              >
                去审核
              </Button>
            ) : t?.buyOpinionFlag == 1 ? (
              <CheckCircleOutlined
                style={{ width: 22, height: 22, color: '#35d733' }}
              />
            ) : t?.buyOpinionFlag == -1 ? (
              <CloseCircleOutlined
                style={{ width: 22, height: 22, color: 'red' }}
              />
            ) : (
              ''
            )}
          </>
        )
      },
    },
    {
      title: '质量审核意见',
      dataIndex: 'qualityAuditFlag',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <>
            {t?.qualityAuditFlag == 0 ? (
              <Button
                type='link'
                size='small'
                disabled={t?.isEdit?.toString() == '0' ? true : false}
                onClick={() => {
                  onClick('goForReview', t, '2')
                }}
              >
                去审核
              </Button>
            ) : t?.qualityAuditFlag == 1 ? (
              <CheckCircleOutlined
                style={{ width: 22, height: 22, color: '#35d733' }}
              />
            ) : t?.qualityAuditFlag == -1 ? (
              <CloseCircleOutlined
                style={{ width: 22, height: 22, color: 'red' }}
              />
            ) : (
              ''
            )}
          </>
        )
      },
    },
    {
      title: '审批意见',
      dataIndex: 'approvalOpinionFlag',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <>
            {t?.approvalOpinionFlag == 0 ? (
              <Button
                type='link'
                size='small'
                disabled={t?.isEdit?.toString() == '0' ? true : false}
                onClick={() => {
                  onClick('goForReview', t, '3')
                }}
              >
                去审核
              </Button>
            ) : t?.approvalOpinionFlag == 1 ? (
              <CheckCircleOutlined
                style={{ width: 22, height: 22, color: '#35d733' }}
              />
            ) : t?.approvalOpinionFlag == -1 ? (
              <CloseCircleOutlined
                style={{ width: 22, height: 22, color: 'red' }}
              />
            ) : (
              ''
            )}
          </>
        )
      },
    },

    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '12rem',
      render: function Element(_, t) {
        return (
          <>
            <Button
              style={{ marginRight: '6px' }}
              type='primary'
              size='small'
              onClick={() => {
                onClick('edit', t)
              }}
            >
              编辑
            </Button>
            <Button
              danger
              ghost
              style={{ marginRight: '6px' }}
              type='primary'
              size='small'
              disabled={t?.isEdit == 1 ? false : true}
              onClick={() => {
                onClick('delete', t)
              }}
            >
              删除
            </Button>
            <Button
              type='primary'
              ghost
              size='small'
              onClick={() => {
                onClick('print', t)
              }}
            >
              打印
            </Button>
          </>
        )
      },
    },
  ]
}
